module.exports = __webpack_public_path__ + "img/ph-3.7c5d6916.jpg";